import requester from '@/lib/axios';
import Flag, { FlagTypeEnum } from '@/models/Flag';
import { BaseFilters, ListServiceFunc } from '@/models/Service';

export type FlagFilters = BaseFilters & {
  name?: string;
  type?: FlagTypeEnum;
};

export const listFlags: ListServiceFunc<Flag, FlagFilters> = async params => {
  const { data } = await requester().get(`flags/`, {
    params,
  });
  return data;
};

export const createFlag = async (flag: Omit<Flag, 'id'>) => {
  const { data } = await requester().post<Flag>('flags/', flag);
  return data;
};

export const updateFlag = async (flagId: number, flag: Partial<Flag>) => {
  const { data } = await requester().patch<Flag>(`flags/${flagId}/`, flag);
  return data;
};
